// /src/hooks/usePriceFile.js
import { useEffect } from "react";
import { UPDATE_APP, updateAPP } from "../../redux_store/appState";
import { fetchTimeout, RehydrateThumbnails } from "../../components/Common";
import { API_BASE, PRICEFILE_KEY } from "../../AppConfig";
import { decryptData, getStoreDatabase } from "../../redux_store/database";

const usePriceFile = ({ dispatch }) => {
    useEffect(() => {
        return new Promise((resolve) => {
            let api_url = API_BASE() + "admin/GetPriceRise";

            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    dispatch({
                        type: UPDATE_APP,
                        parameter: "priceRise",
                        value: json,
                    });
                })
                .catch((e) => {
                    return resolve("ERROR");
                });
        });
    }, []);
};

export default usePriceFile;
